module.exports = __webpack_public_path__ + "static/img/dataDashboards.623141de.png";